// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drag-over[data-v-c78d0f9c]{background-color:#e0f7fa}", ""]);
// Exports
module.exports = exports;
